module.exports = __webpack_public_path__ + "e7ca4477cf64647c2f6f380eda541563.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/mystirio.jpg
// module id = 634
// module chunks = 0